module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.2-82.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.2.md
// module id = 498
// module chunks = 348